import { useEffect, useState } from "react";
import { fetchData, GET_ALL_NEWS } from "../../components/Service";
import { Link, useParams } from "../../../node_modules/react-router-dom/dist/index";
import { getEmbededYoutubeUrl, scrollTop } from "../../components/Helper";

const News = () => {
	const [list, setList] = useState([]);
	const [pageUrl, setPageUrl] = useState();
	const [notFound, setNotFound] = useState(false);

	const getList = () => {
		fetchData(pageUrl ? pageUrl : GET_ALL_NEWS, "GET", "", false, false, (res) => {
			if (res.status) {
				setNotFound(false);
				setList(res?.data);
			} else {
				setNotFound(true);
				setList([]);
			}
		});
	};

	useEffect(() => {
		scrollTop();
		getList();
	}, []);

	useEffect(() => {
		scrollTop();
		if (pageUrl) {
			getList();
		}
	}, [pageUrl]);

	return (
		<div class="col-lg-12">
			<div class="card card-forum">
				<div class="card-header usa-bg px-1">
					<div className="national-bg">
						<div className="row d-flex align-items-center ind1">
							<div className="col-lg-3">
								<h4 class="text-white d-flex mb-0 py-2">News & Articles</h4>
							</div>
						</div>
					</div>
				</div>
				<div class="card-body bg-white p-1 body-minh">
					<div className="row">
						{list?.data &&
							list?.data?.length > 0 &&
							list?.data?.map((item) => (
								<div key={item.id} class="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 event_n mb-1">
									<div class="card-grid-2 hover-up h-100 mb-0">
										<div class="">
											<iframe src={getEmbededYoutubeUrl(item.video_link)} height={300} title="YouTube Video" allowFullScreen />
										</div>
										<div class="card-block-info position-relative">
											<h6>
												<Link to={`/news-articles/${item.id}`}>{item.title}</Link>
											</h6>
										</div>
									</div>
								</div>
							))}
						{notFound && <div className="text-center h6 text-danger py-3">No Records Found!</div>}
					</div>
					{list?.data && (
						<nav className="pt-3">
							<ul className="pagination justify-content-end">
								<li className={`page-item ${list.prev_page_url ? "" : "disabled"}`}>
									<button type="button" className="page-link" onClick={() => setPageUrl(list.prev_page_url)}>
										<span aria-hidden="true">&laquo;</span> Previous
									</button>
								</li>
								<li className={`page-item ${list.next_page_url ? "" : "disabled"}`}>
									<button type="button" className="page-link" onClick={() => setPageUrl(list.next_page_url)}>
										Next <span aria-hidden="true">&raquo;</span>
									</button>
								</li>
							</ul>
						</nav>
					)}
				</div>
			</div>
		</div>
	);
};

export default News;
